import { cn } from '@/lib/cn';

/** A raised pane surface. The app's only card. */
export function Panel({ className, children, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('rounded-md border border-line bg-panel', className)} {...rest}>
      {children}
    </div>
  );
}

export interface PanelHeaderProps {
  title: React.ReactNode;
  /** Quiet annotation next to the title. */
  sub?: React.ReactNode;
  /** Right-aligned controls. */
  actions?: React.ReactNode;
  className?: string;
}

export function PanelHeader({ title, sub, actions, className }: PanelHeaderProps) {
  return (
    <div className={cn('flex items-center gap-2.5 border-b border-line px-3.5 py-2.5', className)}>
      <span className="text-row font-semibold text-ink">{title}</span>
      {sub && <span className="text-caption text-ink-3">{sub}</span>}
      {actions && <span className="ml-auto flex items-center gap-2">{actions}</span>}
    </div>
  );
}

/** Uppercase section label inside rails and queues. */
export function RailLabel({ children, count, className }: { children: React.ReactNode; count?: React.ReactNode; className?: string }) {
  return (
    <div className={cn('flex items-baseline justify-between px-2 pb-1.5 pt-2 text-caption font-semibold uppercase tracking-wider text-ink-3', className)}>
      <span>{children}</span>
      {count !== undefined && <span className="mono font-normal">{count}</span>}
    </div>
  );
}
